import { useEffect, useState } from 'react';

const useFetch = (fetcher: any, setData: any, setError: any) => {
  const [isLoading, setIsLoading] = useState(true);
  const [fetchError, setFetchError] = useState();
  const [fetchData, setFetchData] = useState();

  useEffect(() => {
    const fetch = async () => {
      setIsLoading(true);
      const { error, data } = await fetcher();

      if (error) {
        console.log(error);
        setFetchError(error);
        if (setError) setError(error);
        setIsLoading(false);
        return;
      }

      setFetchData(data);
      if (setData) setData(data);
      setIsLoading(false);
    };

    fetch();
  }, []);

  return {
    error: fetchError,
    data: fetchData,
    isLoading,
  };
};

export default useFetch;
